var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-views-shell"},[(_vm.refreshload)?_c('loading',{attrs:{"backcolor":"#ffa976"}}):_vm._e(),_c('BenefitCardListPanel',{ref:"listPanel",on:{"cards-loaded":_vm.onCardsLoaded}}),_c('foot-nav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }